import React, { Component } from 'react'
import GoogleMap from 'google-map-react'
import Mark from './mark'

export default class Map extends Component {

  constructor (props) {
    super(props)

    this.map=null;
    this.maps=null;

  }

  componentWillReceiveProps(next){
    if(this.map){
      this.findPlaces(this.map, this.maps, next.lat, next.lng)
    }
  }

  _createMapOptions(maps){
    return {
      panControl: false,
      mapTypeControl: false,
      scrollwheel: false
    }
  }

  findPlaces(map, maps, lat, lng) {
    this.map=map;
    this.maps=maps;

    var placeLocation = {lat: lat, lng: lng};

    var that = this;

    const consultas = [
      {name: 'Subtes', icon: 'fa fa-subway fa-lg', type: 'subway_station'},
      {name: 'Trenes', icon: 'fa fa-train fa-lg', type: 'train_station'},
      {name: 'Micros', icon: 'fa fa-bus fa-lg', type: 'bus_station'},
      {name: 'Universidades', icon: 'fa fa-university fa-lg', type: 'university'},
      {name: 'Hospitales', icon: 'fa fa-hospital-o fa-lg', type: 'hospital'},
      {name: 'Shoppings', icon: 'fa fa-shopping-bag fa-lg', type: 'shopping_mall'},
      {name: 'Aeropuertos', icon: 'fa fa-plane fa-lg', type: 'airport'},
    ];

    let service = new google.maps.places.PlacesService(map);

    if (maps.places) {
      const promises = consultas.map((consulta) =>
        new Promise((resolve) => {
          service.nearbySearch({location: placeLocation, radius: '500', types: [`${consulta.type}`]}, function(results, status) {
              if (status === 'OK'){
                resolve({name: `${consulta.name}`, cant: results.length, icon: `${consulta.icon}`})
              }else{
                resolve([])
              }
          });
        }),
      )

      Promise.all(promises).then((params) => {
        let arrayPlaces = [].concat(...params)
        that.props.addPlacesInfo(arrayPlaces)
      }, error => console.error);
    }
  }

  render () {

    let lat = parseFloat(this.props.lat)
    let lng = parseFloat(this.props.lng)
    let zone = this.props.zone
    let zoom = 15;
    let center = { lat: lat, lng: lng }

    const API_KEY = "AIzaSyCm1MEYAHjkfpE-ygYkVPp5-0YIYuD8rxs";

    return (
      <GoogleMap
        resetBoundsOnResize={true}
        yesIWantToUseGoogleMapApiInternals={true}
        options={this._createMapOptions}
        center={center}
        defaultZoom={zoom}
        onGoogleApiLoaded={({map, maps}) => this.findPlaces(map, maps, lat, lng)}
        bootstrapURLKeys={{
          key: API_KEY,
          libraries: "geometry"
        }}
        >
       <Mark lat={lat} lng={lng} zone={zone} />
      </GoogleMap>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/PageNeighborhoods/components/Map/index.js